import React from 'react';
import _ from 'lodash';

import { useLineItemsWidgetQuery } from 'generated/graphql';
import Big from 'big.js';



export interface ILineItem {
  id: string;
  productName: string;
  lineTotalCents: Big;
  quantity: number;
  sku: string;
}

export interface IData {
  lineItems: ILineItem[];
}

export function useQuery(orderId: string) {
  const tuple = useLineItemsWidgetQuery({
    variables: {
      orderId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        lineItems: _.map(tuple.data?.orderLite?.lineItems ?? [], (lineItem): ILineItem => ({
          id: lineItem.id,
          lineTotalCents: new Big(lineItem.itemTotalCents).plus(lineItem.taxTotalCents).plus(lineItem.feeTotalCents),
          productName: lineItem.productName,
          quantity: lineItem.quantity,
          sku: lineItem.sku
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
